var _g, _path, _rect, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandlingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2078_94385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 22L41.25 22.2505",
    stroke: "#98249A",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 34L34 34",
    stroke: "#0A70B8",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14.7222C11 14.2655 11.2011 13.8274 11.5592 13.5044C11.9172 13.1814 12.4028 13 12.9091 13H32H51.0909C51.5972 13 52.0828 13.1814 52.4408 13.5044C52.7989 13.8274 53 14.2655 53 14.7222V40.5556C53 41.4691 52.5977 42.3452 51.8817 42.9911C51.1656 43.6371 50.1945 44 49.1818 44H28.1818",
    stroke: "#26BC96",
    strokeWidth: 3.75,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22V28.1954V40.5861V42C11 43.1046 11.8954 44 13 44H22",
    stroke: "#FBBF00",
    strokeWidth: 3.75,
    strokeLinecap: "square"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 11C50.2091 11 52 12.7909 52 15V42C52 44.2091 50.2091 46 48 46H30V35.8701H38.125C39.1605 35.8701 40 35.0307 40 33.9951C40 32.9596 39.1605 32.1201 38.125 32.1201H30V24H43.125C44.1605 24 45 23.1605 45 22.125C45 21.0895 44.1605 20.25 43.125 20.25H30V11H48Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 36,
    width: 16,
    height: 13,
    rx: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 36H45.5C43.1 36 41.5 37.1471 41.5 39.8235V45.1765C41.5 47.8529 43.1 49 45.5 49H53.5C55.9 49 57.5 47.8529 57.5 45.1765V39.8235C57.5 37.1471 55.9 36 53.5 36ZM44.9 44.4118C44.9 44.7253 44.628 44.9853 44.3 44.9853C43.972 44.9853 43.7 44.7253 43.7 44.4118V40.5882C43.7 40.2747 43.972 40.0147 44.3 40.0147C44.628 40.0147 44.9 40.2747 44.9 40.5882V44.4118ZM49.5 44.7941C48.172 44.7941 47.1 43.7694 47.1 42.5C47.1 41.2306 48.172 40.2059 49.5 40.2059C50.828 40.2059 51.9 41.2306 51.9 42.5C51.9 43.7694 50.828 44.7941 49.5 44.7941ZM55.3 44.4118C55.3 44.7253 55.028 44.9853 54.7 44.9853C54.372 44.9853 54.1 44.7253 54.1 44.4118V40.5882C54.1 40.2747 54.372 40.0147 54.7 40.0147C55.028 40.0147 55.3 40.2747 55.3 40.5882V44.4118Z",
    fill: "#FBBF00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2078_94385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandlingActive);
export default __webpack_public_path__ + "static/media/HandlingActive.d6e8fa8e386e5fa3901e0a38fa48c8a8.svg";
export { ForwardRef as ReactComponent };